export default "__VITE_ASSET__c0d94791__"